Wee.fn.make('prayWithUs', {
	init: function() {
		var dropdown = new Wee.fn.dropdown();

		dropdown.init();
	}
});